import { render, staticRenderFns } from "./PlacesList.vue?vue&type=template&id=3e6fd1d4"
import script from "./PlacesList.vue?vue&type=script&lang=js"
export * from "./PlacesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports